import styled from 'styled-components';

export const RadioInputContainer = styled.div`
  & button > div {
    padding-right: 0;
  }
`;
